/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export const parseMfaToken = (mfaToken: string): Record<string, string> => {
    const base64Url: string = mfaToken.split('.')[1];
    const base64: string = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const encodedJsonPayload: string = atob(base64).split('')
        .map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('');
    const jsonPayload: string = decodeURIComponent(encodedJsonPayload);

    return JSON.parse(jsonPayload);
};
